import type { CalendarEvent } from "../types/types";

export const calculateEventMetrics = (
  evt: CalendarEvent,
  data: { date: string; revenue_value: number }[],
  windowDays: number = 3 // Default to 3 days
) => {
  const getAverageRevenue = (startDate: string, days: number, data: { date: string; revenue_value: number }[]) => {
    let totalRevenue = 0;
    let validDays = 0;
    const start = new Date(startDate);

    for (let i = 0; i < days; i++) {
      const currentDate = new Date(start);
      currentDate.setDate(start.getDate() + i);
      const revenue = data.find((d) => d.date === currentDate.toISOString().slice(0, 10))?.revenue_value;
      if (revenue !== undefined) {
        totalRevenue += revenue;
        validDays++;
      }
    }

    return validDays > 0 ? totalRevenue / validDays : 0; // Return 0 if no valid data
  };

  // Calculate "Before" revenue
  const beforeStartDate = new Date(new Date(evt.startAt).getTime() - windowDays * 24 * 60 * 60 * 1000)
    .toISOString()
    .slice(0, 10);
  const beforeRevenue = getAverageRevenue(beforeStartDate, windowDays, data);

  // Calculate "During" revenue
  const duringRevenue = getAverageRevenue(
    evt.startAt.slice(0, 10),
    Math.ceil((new Date(evt.endAt).getTime() - new Date(evt.startAt).getTime()) / (1000 * 60 * 60 * 24)) + 1,
    data
  );

  // Calculate "After" revenue
  const afterStartDate = new Date(new Date(evt.endAt).getTime() + 24 * 60 * 60 * 1000)
    .toISOString()
    .slice(0, 10);
  const afterRevenue = getAverageRevenue(afterStartDate, windowDays, data);

  // Calculate growth percentages
  const growthBeforeToDuring =
    beforeRevenue > 0 ? ((duringRevenue - beforeRevenue) / beforeRevenue) * 100 : 0;

  const growthDuringToAfter =
    duringRevenue > 0 ? ((afterRevenue - duringRevenue) / duringRevenue) * 100 : 0;

  return {
    beforeRevenue,
    duringRevenue,
    afterRevenue,
    growthBeforeToDuring,
    growthDuringToAfter,
  };
};